import { PAGE_SIZE } from '../data/queryFactories'
import { baseServiceExportExcel } from './baseServiceExportExcel'
class ExportExcelAccountUser extends baseServiceExportExcel {
  async export(payloads) {
    try {
      const payload = {
        pageSize: payloads?.pageSize ?? PAGE_SIZE,
        pageNumber: payloads?.pageNumber ?? 0,
        keywords: payloads?.keywords ?? null,
      }
      const res = await this.post('users/export/all', payload)
      if (!res?.ok || res?.status !== 200)
        console.error('Lỗi kết nối API!', res?.statusText)
      return res
    } catch (error) {
      console.error(error.message)
    }
  }
}
export const exportExcelAccountUser = new ExportExcelAccountUser()
